import { Rule } from "./../../../../../../models/Rule";
import { PortefeuilleDetail } from "./../../../../../../models/PortefeuilleDetail";
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-rule",
  templateUrl: "./rule.component.html",
  styleUrls: ["./rule.component.scss"],
})
export class RuleComponent implements OnInit {
  @Input()
  portefeuilleDetail: PortefeuilleDetail;

  @Input()
  rules: Rule[];

  constructor() {}

  ngOnInit() {}

  isRuleParcourue(codeRule: string) {
    return this.portefeuilleDetail.ruleParcourues.some(
      (x) => x.codeRule === codeRule
    );
  }

  getRules() {
    return this.rules;
  }

  getAnotherRuleParcourues() {
    let ruleCodes = this.rules.map((a) => a.codeRule);
    let difference = this.portefeuilleDetail.ruleParcourues.filter(
      (x) => !ruleCodes.includes(x.codeRule)
    );
    return difference;
  }
}
